import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonList,
  IonItemDivider,
  IonLabel,
  IonItem,
  IonFab,
  IonFabButton,
  IonIcon,
  useIonToast,
} from "@ionic/react";
import { add } from "ionicons/icons";
import "./Tab3.css";

const Tab3: React.FC<{
  addGold: (goldToAdd: number) => void;
  addExp: (expToAdd: number) => void;
}> = ({ addGold, addExp }) => {
  const [present] = useIonToast();

  const finishQuest = () => {
    addGold(50);
    addExp(50);
    present({
      message: "Quest Completed! (50 gold + 50 exp)",
      duration: 3000,
    });
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Quests</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">Quests</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonFab vertical="bottom" horizontal="end" slot="fixed">
          <IonFabButton>
            <IonIcon icon={add} />
          </IonFabButton>
        </IonFab>

        <IonList>
          <IonItemDivider color="light">
            <IonLabel class="ion-text-uppercase">
              <strong>Daily Quests</strong>
            </IonLabel>
          </IonItemDivider>

          <IonItem button onClick={finishQuest}>
            <IonLabel>Drink Water</IonLabel>
          </IonItem>
          <IonItem button onClick={finishQuest}>
            <IonLabel>Clear the trash</IonLabel>
          </IonItem>

          <IonItemDivider color="light">
            <IonLabel class="ion-text-uppercase">
              <strong>Normal Quests</strong>
            </IonLabel>
          </IonItemDivider>

          <IonItem button onClick={finishQuest}>
            <IonLabel>Buy Batteries</IonLabel>
          </IonItem>
          <IonItem button onClick={finishQuest}>
            <IonLabel>Do video interview</IonLabel>
          </IonItem>
          <IonItem button onClick={finishQuest}>
            <IonLabel>Send car for repair</IonLabel>
          </IonItem>

          <IonItemDivider color="light">
            <IonLabel class="ion-text-uppercase">
              <strong>Party Quests</strong>
            </IonLabel>
          </IonItemDivider>

          <IonItem button onClick={finishQuest}>
            <IonLabel>Do slides for CS1231</IonLabel>
          </IonItem>
        </IonList>
      </IonContent>
    </IonPage>
  );
};

export default Tab3;
